<template>
  <div class="lmb-layout">
    <div class="lmb-layout-title">
      <layout-title :title-text="titleText"></layout-title>
    </div>
    <slot class="lmb-layout-content" name="content"></slot>
  </div>
</template>

<script>
import LayoutTitle from './layout-title'
export default {
  components: {
    LayoutTitle
  },
  props: {
    titleText: {
      default: '',
      type: String,
      require: true
    }
  }
}
</script>

<style lang="less" scoped>
.lmb-layout-title{
  margin-bottom: 20px;
  padding-top: 24px;
}
</style>
